export default __webpack_public_path__ + "static/media/App-Store.304e7150.svg";